export const SET_SUBSCRIPTIONS = 'SET_SUBSCRIPTIONS';
export const SET_SUBSCRIPTION = 'SET_SUBSCRIPTION';
export const ADD_SUBSCRIPTIONS = 'ADD_SUBSCRIPTIONS';
export const ADD_SUBSCRIPTION = 'ADD_SUBSCRIPTION';
export const UPDATE_SUBSCRIPTION = 'UPDATE_SUBSCRIPTION';
export const REMOVE_SUBSCRIPTION = 'REMOVE_SUBSCRIPTION';
